import UserAuthenticationService from './UserAuthenticationService';
import { makeRequest } from 'js/services/Network';
import AnonymousId from 'js/services/AnonymousId';

/**
 * Normal (username/password) registration service for PayOnDelivery
 *
 * @class PayOnDeliveryReg
 */
class PayOnDeliveryReg extends UserAuthenticationService {
  /**
   * Trigger PayOnDelivery user registration
   *
   * @returns Promise
   * @memberof PayOnDeliveryReg
   */
  login = async (scope = '', data = {}) =>
    (await makeRequest('register-email-user', null, { anonymous_id: AnonymousId, ...data })).data;

  /**
   * Trigger PayOnDelivery logout
   * https://developers.facebook.com/docs/reference/javascript/FB.logout/
   *
   * @returns
   * @memberof PayOnDeliveryReg
   */
  logout = () => makeRequest('logout');
}

export default new PayOnDeliveryReg();
